import { alpha, styled } from "@mui/material/styles";
import { Container, Typography, Skeleton } from "@mui/material";

export const Root = styled(Container)(() => ({
  marginTop: 75,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  padding: "0px",
}));

export const Item = styled("div")(({ theme }) => ({
  position: "relative",
  margin: "0 7px 22px",
  width: 91,
  textAlign: "center",
  display: "block",
  "&:hover .figure::before": {
    opacity: 0.5,
  },
  "&:nth-of-type(5n+1) .placeholder": {
    backgroundColor: alpha(theme.palette.overlays.blue, 0.5),
  },
  "&:nth-of-type(5n+2) .placeholder": {
    backgroundColor: alpha(theme.palette.overlays.orange, 0.5),
  },
  "&:nth-of-type(5n+3) .placeholder": {
    backgroundColor: alpha(theme.palette.overlays.violin, 0.5),
  },
  "&:nth-of-type(5n+4) .placeholder": {
    backgroundColor: alpha(theme.palette.overlays.pink, 0.5),
  },
  "&:nth-of-type(5n) .placeholder": {
    backgroundColor: alpha(theme.palette.overlays.green, 0.5),
  },
  "&:nth-of-type(5n+1) .figure::before": {
    backgroundColor: theme.palette.overlays.blue,
  },
  "&:nth-of-type(5n+2) .figure::before": {
    backgroundColor: theme.palette.overlays.orange,
  },
  "&:nth-of-type(5n+3) .figure::before": {
    backgroundColor: theme.palette.overlays.violin,
  },
  "&:nth-of-type(5n+4) .figure::before": {
    backgroundColor: theme.palette.overlays.pink,
  },
  "&:nth-of-type(5n) .figure::before": {
    backgroundColor: theme.palette.overlays.green,
  },
  "&:nth-of-type(5n+1):hover .name": {
    color: theme.palette.overlays.blue,
  },
  "&:nth-of-type(5n+2):hover .name": {
    color: theme.palette.overlays.orange,
  },
  "&:nth-of-type(5n+3):hover .name": {
    color: theme.palette.overlays.violin,
  },
  "&:nth-of-type(5n+4):hover .name": {
    color: theme.palette.overlays.pink,
  },
  "&:nth-of-type(5n):hover .name": {
    color: theme.palette.overlays.green,
  },
  [theme.breakpoints.up("mobile")]: {
    margin: "0 23.25px 20px",
    width: 116,
  },
  [theme.breakpoints.up("tablet")]: {
    width: 139.5,
    margin: "0 26.5px 55.53px",
  },
}));

export const Figure = styled("span")(({ theme }) => ({
  display: "block",
  position: "relative",
  height: 91,
  width: 91,
  "&::before": {
    content: "''",
    display: "block",
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    position: "absolute",
    left: 0,
    top: 0,
    opacity: 0,
    willChange: "opacity",
    transition: "opacity 0.1s cubic-bezier(0.61, 1, 0.88, 1)",
  },
  [theme.breakpoints.up("mobile")]: {
    height: 116,
    width: 116,
  },
  [theme.breakpoints.up("tablet")]: {
    height: 140,
    width: 140,
  },
}));

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  display: "inline-block",
  position: "absolute",
  zIndex: "-1",
  top: "0",
  left: "0",
  width: 91,
  height: 91,
  [theme.breakpoints.up("mobile")]: {
    width: 116,
    height: 116,
  },
  [theme.breakpoints.up("tablet")]: {
    width: 139.5,
    height: 139.5,
  },
}));

export const Image = styled("img")({
  width: "100%",
  height: "100%",
  borderRadius: "50%",
  display: "block",
});

export const Name = styled(Typography)(({ theme }) => ({
  display: "block",
  marginTop: 7,
  [theme.breakpoints.up("mobile")]: {
    marginTop: 9,
  },
  [theme.breakpoints.up("tablet")]: {
    marginTop: 11,
    fontSize: theme.typography.large.fontSize,
    color: theme.palette.primary.main,
  },
}));
